/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import {
  modalController,
} from '@ionic/vue';
import Report from '../components/Report/Report.vue';

const openReportModalHandle = () => modalController
  .create({
    component: Report,
    cssClass: 'fullscreen',
  })
  .then((modalElement) => {
    modalElement.present();
    modalElement.onDidDismiss();
  });

export {
  openReportModalHandle,
};
